export const biFoldDoubleSidedOdds = [
    "3L3R",
    "5L5R",
    "5L1R",
    "1L5R",
    "3L1R",
    "1L3R",
]